/**
 * Optional gitignored overrides: copy `profilePhotos.local.example.js` → `profilePhotos.local.js`.
 * Production: keep local file absent; photos come from Supabase (`team_members.photo_url`).
 */
const localMods = import.meta.glob('./profilePhotos.local.js', { eager: true });
const fromLocal =
  /** @type {Record<string, string>} */ (Object.values(localMods)[0]?.PROFILE_PHOTOS ?? {});

export const PROFILE_PHOTOS = { ...fromLocal };
